var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tt",class:_vm.$mq},[_c('img',{attrs:{"src":require("@/assets/images/footer/" + _vm.$config.tt_footer),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }